import React from 'react';
import {
    Box,
    CircularProgress,
    List,
    ListItemButton,
    ListItemAvatar,
    ListItemText,
    TextField,
    Typography,
} from '@mui/material';
import UserAvatar from '../../../../components/UserAvatar';

function userLabel(u) {
    if (!u) return '';
    return (
        u.displayName
        || [u.firstName, u.lastName].filter(Boolean).join(' ').trim()
        || u.email
        || u.id
    );
}

/** Search field + always-visible scrollable user list (works reliably inside MUI Dialog). */
export default function SearchUsers({
    query,
    setQuery,
    searchLoading,
    results,
    searchError,
    onAddUser,
}) {
    return (
        <Box>
            <TextField
                fullWidth
                size="small"
                placeholder="Search users by name or email"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoComplete="off"
            />

            <Box
                sx={{
                    mt: 1,
                    height: 220,
                    overflow: 'auto',
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                }}
            >
                {searchLoading ? (
                    <Box sx={{display: 'flex', justifyContent: 'center', py: 3}}>
                        <CircularProgress size={24}/>
                    </Box>
                ) : searchError ? (
                    <Typography variant="body2" color="error" sx={{p: 2}}>
                        {searchError}
                    </Typography>
                ) : !results?.length ? (
                    <Typography variant="body2" color="text.secondary" sx={{p: 2}}>
                        {query.trim() ? 'No users match your search.' : 'No users available to add.'}
                    </Typography>
                ) : (
                    <List dense disablePadding>
                        {results.map((option) => (
                            <ListItemButton
                                key={option.id}
                                onClick={() => onAddUser(option)}
                            >
                                <ListItemAvatar>
                                    <UserAvatar user={option} userId={option.id}/>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={userLabel(option)}
                                    secondary={option.email || option.id}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Box>
        </Box>
    );
}
